import { isResourceDetailDocument } from '../../resources/utils/resourceDetailGuards.js';
import useDocumentPreviewable from './useDocumentPreviewable.js';

const useDocumentUnpreviewable = (resource) => {
  const isDocument = resource ? isResourceDetailDocument(resource) : false;
  const isDocumentPreviewable = useDocumentPreviewable(resource);
  return isDocument && !isDocumentPreviewable;
};

export { useDocumentUnpreviewable as default };
//# sourceMappingURL=useDocumentUnpreviewable.js.map
